// NEW_FILE_JUSTIFIED: Placeholder page wrappers for company portal and insurance org routes, extracted to keep PageWrappers.tsx under 300 lines
import { AppLayoutMemo } from '@/components/layout';
import { CompaniesListPage } from '@/pages/insurance/CompaniesListPage';
import { CompanyDetailPage } from '@/pages/insurance/CompanyDetailPage';
import { BankAccountsPage } from '@/pages/insurance/BankAccountsPage';
import { InvoicesListPage } from '@/pages/insurance/InvoicesListPage';
import { InvoiceFormPage } from '@/pages/insurance/InvoiceFormPage';
import { EmployeesListPage } from '@/pages/company/EmployeesListPage';
import { EmployeeDetailPage } from '@/pages/company/EmployeeDetailPage';
import { NewEmployeePage } from '@/pages/company/NewEmployeePage';
import { EditEmployeePage } from '@/pages/company/EditEmployeePage';
import { CompanySettingsPage } from '@/pages/company/CompanySettingsPage';
import { CompanyManagersPage } from '@/pages/company/CompanyManagersPage';
import { CompanyInvoicesListPage } from '@/pages/company/CompanyInvoicesListPage';
import { InvoiceDetailPage } from '@/pages/company/InvoiceDetailPage';
import { CompanyPoliciesListPage } from '@/pages/company/CompanyPoliciesListPage';
import { CompanyPolicyDetailPage } from '@/pages/company/CompanyPolicyDetailPage';
import { InsuranceEmployeeDetailPage } from '@/pages/insurance/InsuranceEmployeeDetailPage';
import { PaymentsListPage } from '@/pages/insurance/PaymentsListPage';
import { InsuranceSettingsPage } from '@/pages/insurance/InsuranceSettingsPage';
import { ClaimsListPage } from '@/pages/insurance/ClaimsListPage';

export function CompanyEmployeesListPageWrapper() {
  return (
    <AppLayoutMemo>
      <EmployeesListPage />
    </AppLayoutMemo>
  );
}

export function CompanyNewEmployeePageWrapper() {
  return (
    <AppLayoutMemo>
      <NewEmployeePage />
    </AppLayoutMemo>
  );
}

// NEW_FUNCTION_JUSTIFIED: Route wrapper for /company/employees/:id/edit, matching the pattern of all other employee page wrappers in this file
export function CompanyEditEmployeePageWrapper() {
  return (
    <AppLayoutMemo>
      <EditEmployeePage />
    </AppLayoutMemo>
  );
}

export function CompanyEmployeeDetailPageWrapper() {
  return (
    <AppLayoutMemo>
      <EmployeeDetailPage />
    </AppLayoutMemo>
  );
}

export function CompanyPoliciesListPageWrapper() {
  return (
    <AppLayoutMemo>
      <CompanyPoliciesListPage />
    </AppLayoutMemo>
  );
}

export function CompanyPolicyDetailPageWrapper() {
  return (
    <AppLayoutMemo>
      <CompanyPolicyDetailPage />
    </AppLayoutMemo>
  );
}

export function CompanyInvoicesListPageWrapper() {
  return (
    <AppLayoutMemo>
      <CompanyInvoicesListPage />
    </AppLayoutMemo>
  );
}

export function CompanyInvoiceDetailPageWrapper() {
  return (
    <AppLayoutMemo>
      <InvoiceDetailPage />
    </AppLayoutMemo>
  );
}

export function CompanyManagersPageWrapper() {
  return (
    <AppLayoutMemo>
      <CompanyManagersPage />
    </AppLayoutMemo>
  );
}

export function CompanySettingsPageWrapper() {
  return (
    <AppLayoutMemo>
      <CompanySettingsPage />
    </AppLayoutMemo>
  );
}

export function CompaniesListPageWrapper() {
  return (
    <AppLayoutMemo>
      <CompaniesListPage />
    </AppLayoutMemo>
  );
}

export function CompanyDetailPageWrapper() {
  return (
    <AppLayoutMemo>
      <CompanyDetailPage />
    </AppLayoutMemo>
  );
}

export function BankAccountsPageWrapper() {
  return (
    <AppLayoutMemo>
      <BankAccountsPage />
    </AppLayoutMemo>
  );
}

export function InvoicesListPageWrapper() {
  return (
    <AppLayoutMemo>
      <InvoicesListPage />
    </AppLayoutMemo>
  );
}

export function InvoiceFormPageWrapper() {
  return (
    <AppLayoutMemo>
      <InvoiceFormPage />
    </AppLayoutMemo>
  );
}

export function InsuranceEmployeeDetailPageWrapper() {
  return (
    <AppLayoutMemo>
      <InsuranceEmployeeDetailPage />
    </AppLayoutMemo>
  );
}

export function PaymentsListPageWrapper() {
  return (
    <AppLayoutMemo>
      <PaymentsListPage />
    </AppLayoutMemo>
  );
}

export function ClaimsListPageWrapper() {
  return (
    <AppLayoutMemo>
      <ClaimsListPage />
    </AppLayoutMemo>
  );
}

// NEW_FUNCTION_JUSTIFIED: Route wrapper for /insurance/settings, following the pattern of all other page wrappers in this file
export function InsuranceSettingsPageWrapper() {
  return (
    <AppLayoutMemo>
      <InsuranceSettingsPage />
    </AppLayoutMemo>
  );
}
